import React from 'react'
import MoreIcon from '@material-ui/icons/MoreHoriz'
import { makeStyles } from '@material-ui/core'
import IconButton from '@paintscout/ui/components/IconButton'
import type { PopupMenuProps } from '@paintscout/ui/components/PopupMenu'
import PopupMenu from '@paintscout/ui/components/PopupMenu'
import MenuItem from '@paintscout/ui/components/MenuItem'

export interface ActivityActionsProps extends Omit<PopupMenuProps, 'component' | 'classes'> {}

const useStyles = makeStyles((theme) => ({
  button: {
    marginTop: -theme.spacing(0.5),
    '@media print': {
      display: 'none'
    }
  }
}))
export default function ActivityActions(props: ActivityActionsProps) {
  const classes = useStyles(props)

  return (
    <PopupMenu
      component={
        <IconButton size="small" className={classes.button} data-testid="activity-actions">
          <MoreIcon />
        </IconButton>
      }
      {...props}
    />
  )
}

export const ActivityAction = MenuItem
